import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import 'react-table-hoc-fixed-columns/lib/styles.css';
import styled from 'styled-components';

import { IconButton } from 'modules/list';
import { closeModal } from 'actions/modal';
import EditIcon from 'img/edit.png';
import { Header } from 'semantic-ui-react';

import { Row, Button, Separator } from '@cuemath/comps';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 30px;
  padding-right: 30px;
`;

const HeaderHeadWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 5px;
  bottom: 7px;
  border: 1px solid #333;
  background: #ccc;
`;

const HeaderStyle = styled(Header)`
  position: relative;
  bottom: 10px;
`;

const TYPE = {
  board: 'Board',
  topic: 'Topic',
  activity_topic: 'Activity Topic',
  activity_tile: 'Activity Tile',
};

export const demoOptions = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  },
];

class EditFilter extends PureComponent {
  renderFormHeader = () => {
    const { editType } = this.props;

    return (
      <>
        <Separator transparent height={10} />
        {editType && (
          <HeaderHeadWrapper>
            <HeaderStyle as="h3" floated="left">
              <Separator transparent height={10} />
              {TYPE[editType]}
            </HeaderStyle>
          </HeaderHeadWrapper>
        )}
      </>
    );
  };

  render() {
    const { tags, onChecked, isFilterPresent, openAddTopic } = this.props;

    let columnsData = [
      {
        Header: '',
        accessor: 'name',
        Cell: row => {
          return (
            <Row justifyContent="space-around">
              <IconButton
                icon={EditIcon}
                onClick={() =>
                  openAddTopic({
                    data: row.original,
                    isEdit: true,
                  })
                }
              />
            </Row>
          );
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Description',
        accessor: 'description',
      },
      {
        Header: 'Enabled',
        accessor: 'is_live',
        Cell: row => {
          return (
            <Row justifyContent="center">
              <input
                type="checkbox"
                checked={row.original.is_live}
                disabled
                onChange={() => onChecked(row.index, tags.data)}
              />
            </Row>
          );
        },
      },
    ];

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    const isDataArr = tags && Array.isArray(tags) && tags.length > 0;

    return (
      <div>
        {this.renderFormHeader()}
        {!isFilterPresent && (
          <TableWrapper>
            <Separator transparent height={30} />
            <ReactTable
              data={!!tags && isDataArr ? tags : []}
              className="-striped -highlight"
              manual
              showPaginationTop
              showPageSizeOptions={true}
              filterable={false}
              sortable={false}
              resizable={false}
              defaultPageSize={1}
              columns={tableColumns}
            />
            <Separator height={10} transparent />
          </TableWrapper>
        )}
        <Row justifyContent="center">
          <Button label="Add New" onClick={openAddTopic} />
        </Row>
        <Separator height={10} transparent />
      </div>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      closeModal,
    },
    dispatch,
  ),
}))(EditFilter);
